import React from 'react'

const React_Coding_Practice_44 = () => {
  return (
    <div>
      <h1>Coding Pratice 44</h1>
    </div>
  )
}

export default React_Coding_Practice_44
